<template>
  <Layout class="g-wrapper g-vertical-block">
    <Content class="g-main-wrapper g-vertical-block">
      <Row :gutter="12">
        <Col span="24" class="c-bar">
          <div class="c-bar-back" @click="back">
            <Icon type="ios-arrow-back" size="24" />
            <span>返回</span>
          </div>
          <div class="c-bar-title">
            <Breadcrumb>
              <template v-for="(b, i) in crumbs">
                <BreadcrumbItem v-if="b.href" :key="i" :to="posroute(b.href)">
                  <Icon :type="crumbico(i)" size="18" /> {{ b.title }}
                </BreadcrumbItem>
                <BreadcrumbItem v-else :key="i"> <Icon :type="crumbico(i)" size="18" /> {{ b.title }} </BreadcrumbItem>
              </template>
            </Breadcrumb>
          </div>
        </Col>
      </Row>
      <div ref="content" class="c-content">
        <router-view />
      </div>
    </Content>
  </Layout>
</template>
<script>
export default {
  name: 'layoutDetail',
  computed: {
    crumbico() {
      return (i) => this.posicon[i]
    },
    posicon() {
      return ['ios-home-outline', 'md-school', 'logo-buffer']
    },
    posroute() {
      return (b) => {
        return {
          name: b.to,
          query: b.query
        }
      }
    },
    crumbs() {
      return this.$store.state.breadcrumb // store路由数据传参
    },
    backRoute() {
      return this.$store.state.indexRoute // store首页路由
    }
  },
  methods: {
    back() {
      this.$router.back()
      // if (!this.id) this.$router.back()
      // else this.$router.replace({name: this.backRoute})
    }
  }
}
</script>
<style lang="scss" scoped>
.c-bar {
  height: 40px;
  font-size: 14px;

  .c-bar-back {
    width: 80px;
    line-height: 30px;
    display: inline-block;
    border-right: solid 1px #b9b9b9;
    cursor: pointer;

    &:hover {
      span,
      i {
        color: #5cadff;
      }
    }
  }

  .c-bar-title {
    display: inline-block;
    padding-left: 12px;
  }
}

.c-content {
  height: calc(100% - 40px);
  position: relative;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
}
</style>
